import { DiscordIcon } from "@gadgetinc/widgets/src/icons/brands/DiscordIcon";
import { GadgetLogoMark } from "@gadgetinc/widgets/src/icons/GadgetLogo";
import { ShopifyWebhookIcon } from "@gadgetinc/widgets/src/icons/ShopifyWebhookIcon";
import { ThirdPartyIcon } from "@gadgetinc/widgets/src/icons/ThirdPartyIcon";
import { useStyletron } from "baseui";
import { HeadingLarge, HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import type { DocsInterfaceProps } from "../../../../src/chrome/DocsInterface";
import { DocsInterface } from "../../../../src/chrome/DocsInterface";
import { DocsButton, KIND, SIZE } from "../../../../src/components/DocsButton";
import { SplashCard, SplashCardGrid, SplashContentContainer, colors } from "../../../../src/components/SplashPage";
import { DISCORD_INVITE_URL } from "@gadgetinc/widgets";

const GettingStartedHomePage = (props: DocsInterfaceProps) => {
  const [css, $theme] = useStyletron();

  return (
    <DocsInterface {...props} showLeftSideNav={true}>
      <SplashContentContainer $style={{ maxWidth: "980px" }}>
        <HeadingXLarge>Getting started</HeadingXLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Learn the Gadget basics.
        </ParagraphLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200, marginBottom: $theme.sizing.scale1200 })}>
          <SplashCard
            icon={<GadgetLogoMark width={32} />}
            title="Quickstart"
            color={colors.white}
            body="New to Gadget? Build your first full-stack app in 10 minutes!"
            href="/guides/getting-started/quickstarts/web-quickstart"
            copy="Get started →"
          />
          <SplashCard
            title="What is Gadget?"
            color={colors.white}
            body="Learn how Gadget helps developers build apps faster."
            href="/guides/getting-started/what-is-gadget"
            copy="Learn more →"
          />
          <SplashCard
            title="How to build a Gadget app"
            color={colors.white}
            body="A step-by-step explanation of the core concepts needed to build a applications in Gadget."
            href="/guides/getting-started/how-to-build-a-gadget-app"
            copy="Learn more →"
          />
        </SplashCardGrid>
        <HeadingLarge>Start building ecommerce apps</HeadingLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200, marginBottom: $theme.sizing.scale1200 })}>
          <SplashCard
            icon={<ShopifyWebhookIcon $size={32} />}
            title="Shopify quickstart"
            color={colors.white}
            body="Learn how to set up a Shopify connection."
            href="/guides/plugins/shopify/quickstart"
            copy="Get started →"
          />
          <SplashCard
            icon={<ThirdPartyIcon type="bigcommerce" $size={32} />}
            title="BigCommerce quickstart"
            color={colors.white}
            body="Learn how to set up a BigCommerce connection."
            href="/guides/getting-started/quickstarts/bigcommerce-quickstart"
            copy="Get started →"
          />
        </SplashCardGrid>
        <HeadingLarge>Developer resources</HeadingLarge>
        <SplashCardGrid $maxColumns={2} className={css({ marginTop: $theme.sizing.scale1200, marginBottom: $theme.sizing.scale1200 })}>
          <SplashCard
            title="Blog"
            color={colors.white}
            body="Explore app templates, tutorials, coding tips, announcements, and more."
            href="https://gadget.dev/blog"
            copy="View the blog →"
          />
          <SplashCard
            title="Youtube"
            color={colors.white}
            body="Watch our step-by-step guides and interactive tutorials on how to build within Gadget."
            href="https://www.youtube.com/@gadget_dev"
            copy="Watch our videos →"
          />
        </SplashCardGrid>
        <HeadingLarge>Community</HeadingLarge>
        <ParagraphLarge
          $style={{
            paddingTop: $theme.sizing.scale800,
            paddingBottom: $theme.sizing.scale800,
          }}
        >
          Get help from fellow builders!
        </ParagraphLarge>
        <DocsButton
          $as="a"
          kind={KIND.secondary}
          size={SIZE.large}
          startEnhancer={<DiscordIcon />}
          href={DISCORD_INVITE_URL}
          target="_blank"
        >
          Join the Discord
        </DocsButton>
      </SplashContentContainer>
    </DocsInterface>
  );
};

export default GettingStartedHomePage;
